import moment from 'moment'
import apiClient from '@/services/axios'

const actions = {
  async getDashboardData ({ commit, rootState }, payload) {
    try {
      commit('SET_LOADING_DASHBOARD', true)
      const timezone = moment().format('Z')
      const options = {
        method: 'get',
        url: '/data/private/dashboard/vendor',
        params: {
          timezone,
        },
      }
      const response = await apiClient(options)
      let total_amount = 0
      const dataCart = {
        labels: [],
        series: [
          {
            data: [],
            className: 'ct-series-a',
          },
        ],
      }
      const dummyCart = {
        labels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        series: [
          {
            className: 'ct-series-a',
            data: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
            ],
          },
        ],
      }
      response.data.graph_summary.forEach(item => {
        dataCart.labels.push(item.sales_day)
        dataCart.series[0].data.push(item.total_order)
        total_amount += item.total_amount
      })
      commit('SET_TOTAL_WEEKLY_SALES', total_amount)
      commit('SET_DATA_CART', response.data.graph_summary.length > 0 ? dataCart : dummyCart)
      commit('SET_DASHBOARD', response.data)
    } catch (err) {
      console.log(err)
    } finally {
      commit('SET_LOADING_DASHBOARD', false)
    }
  },
}

export default actions
